import { addMonths, isAfter, isBefore, subMonths, subYears } from "date-fns";

const MONTHS_TO_MAX_AGE_IS_CLOSE = 4;
const INFANT_IN_MONTHS = 3;

export const isChild = (childBirthDate: Date, maxAge: number): boolean =>
  isBefore(childBirthDate, subMonths(new Date(), INFANT_IN_MONTHS)) &&
  isAfter(childBirthDate, subYears(new Date(), maxAge));

export const isInfant = (childBirthDate: Date): boolean =>
  isAfter(childBirthDate, subMonths(new Date(), INFANT_IN_MONTHS));

export const isChildCloseToMaxAge = (
  childBirthDate: Date,
  maxAge: number,
): boolean => {
  const childMaxAgeDateOfBirth = subYears(new Date(), maxAge);
  const warnChildCloseToMaxAgeDateOfBirth = addMonths(
    childMaxAgeDateOfBirth,
    MONTHS_TO_MAX_AGE_IS_CLOSE,
  );
  return (
    isAfter(childBirthDate, childMaxAgeDateOfBirth) &&
    isBefore(childBirthDate, warnChildCloseToMaxAgeDateOfBirth)
  );
};
